import { HTMLMarkdown } from "@/components/markdown/HTMLMarkdown";

export type LinkProps = {
  text: string | RegExp;
  href: string;
};
export const LinkableMarkdown = ({
  links,
  children,
  className,
}: {
  links: LinkProps[];
  children: string;
  className?: string;
}) => {
  const linkedChildren = links.reduce((acc, link) => {
    return acc.replace(link.text, `<a href='${link.href}' '>${link.text}</a>`);
  }, children);

  return <HTMLMarkdown className={className}>{linkedChildren}</HTMLMarkdown>;
};
